module.exports = __webpack_public_path__ + "img/create-thirdparty.d7f0f27b.png";